import moment from 'moment'
import i18n from '@/locales'

export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('bill.budget_alert_info_action'),
        permission: 'bill_budgets_perform',
        action: (obj) => {
          const params = {}
          if (obj.alerts && obj.alerts.length > 0) {
            params.alert_threshold_type = obj.alerts[0].alert_threshold_type
            params.alert_threshold = obj.alerts[0].alert_threshold
            params.alert_frequency = obj.alerts[0].alert_frequency
            params.user_ids = obj.alerts[0].user_ids
            params.robot_ids = obj.alerts[0].robot_ids || []
            params.channel = obj.alerts[0].channel && obj.alerts[0].channel.filter(v => !v.includes('robot') && v !== 'users')
          }
          this.$router.push({
            path: '/budget/create_alert',
            query: {
              id: obj.id,
              ...params,
            },
          })
        },
        meta: (obj) => {
          const ret = {
            validate: true,
            tooltip: '',
          }
          if (moment().isSameOrAfter(obj.end_time)) {
            ret.validate = false
            ret.tooltip = i18n.t('bill.budget_expired')
            return ret
          }
          return ret
        },
      },
      {
        label: i18n.t('scope.text_18'),
        permission: 'bill_budgets_delete',
        action: (obj) => {
          this.createDialog('DeleteResDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            title: i18n.t('scope.text_18'),
            name: i18n.t('bill.budget'),
            onManager: this.onManager,
          })
        },
        // meta: (obj) => this.$getDeleteResult(obj),
      },
    ]
  },
}
